module.exports = __webpack_public_path__ + "static/media/Food6.0540884b.jpg";